import { useEffect, useState } from 'react'

import {
  getMockCalendarSettings,
  updateMockCalendarSettings,
} from '../../CalendarSettings.mock'

export function useCalendarSettingsData() {
  const [settings, setSettings] = useState(null)
  const [serverError, setServerError] = useState(null)

  // TODO: read the settings from the calendar settings endpoint once the
  // backend serves it.
  async function handleLoadSettings() {
    return getMockCalendarSettings()
      .then(({ data }) => {
        setSettings(data)
      })
      .catch(error => {
        setServerError(error)
      })
  }

  // TODO: save through the calendar settings endpoint once the backend
  // serves it.
  async function handleSaveSettings(payload) {
    return updateMockCalendarSettings(payload).then(({ data }) => {
      setSettings(data)
    })
  }

  useEffect(() => {
    handleLoadSettings()
  }, [])

  return {
    handleSaveSettings,
    isLoading: !settings && !serverError,
    serverError,
    settings,
  }
}
